import axios from 'axios';
import { loginreq, req } from './axiosFun';
const devEnv = require('../../config/index')


/**
 * 主页
 **/
// 工序任务列表，绩效指标查询
export const getProcessTasks = (params) => { return req("post", devEnv.API_ROOT + "/getProcessTasks", params) };

/**
 * 基础数据
 **/
//---不良品项
// 批量删除
export const nongoodBatchDelete = (params) => { return req("post", devEnv.API_ROOT + "/nongood/batchDelete", params) };
// 查询不良品项列表
export const nongoodGetList = (params) => { return req("post", devEnv.API_ROOT + "/nongood/getList", params) };
// 查询所有不良品项列表
export const getAll = (params) => { return axios.get(devEnv.API_ROOT + "/nongood/getAll?factoryId=" + params).then(res => res.data) };
// 创建不良品项
export const nongoodSave = (params) => { return req("post", devEnv.API_ROOT + "/nongood/save", params) };
// 删除不良品项
export const batchDelete = (params) => { return axios.get(devEnv.API_ROOT + "/nongood/delete?_id=" + params).then(res => res.data) };

//--- 产品定义
// 批量删除
export const productBatchDelete = (params) => { return req("post", devEnv.API_ROOT + "/product/batchDelete", params) };
// 删除
export const productDelete = (params) => { return axios.get(devEnv.API_ROOT + "/product/delete?_id=" + params).then(res => res.data) };
// 查询所有产品列表
export const productGetAll = (params) => { return axios.get(devEnv.API_ROOT + "/product/getAll?factoryId=" + params).then(res => res.data) };
// 查询产品列表
export const productGetList = (params) => { return req("post", devEnv.API_ROOT + "/product/getList", params) };
// 创建和编辑产品
export const productSave = (params) => { return req("post", devEnv.API_ROOT + "/product/save", params) };


// ---单位
// 批量删除
export const unitBatchDelete = (params) => { return req("post", devEnv.API_ROOT + "/unit/batchDelete", params) };
// 删除
export const unitDelete = (params) => { return axios.get(devEnv.API_ROOT + "/unit/delete?_id=" + params).then(res => res.data) };
// 查询所有单位列表
export const unitGetAll = (params) => { return axios.get(devEnv.API_ROOT + "/unit/getAll?factoryId=" + params).then(res => res.data) };
// 查询单位列表
export const unitGetList = (params) => { return req("post", devEnv.API_ROOT + "/unit/getList", params) };
// 创建和编辑单位
export const unitSave = (params) => { return req("post", devEnv.API_ROOT + "/unit/save", params) };

// ---工序
// 批量删除
export const processBatchDelete = (params) => { return req("post", devEnv.API_ROOT + "/process/batchDelete", params) };
// 删除
export const processDelete = (params) => { return axios.get(devEnv.API_ROOT + "/process/delete?_id=" + params).then(res => res.data) };
// 查询所有列表
export const processGetAll = (params) => { return axios.get(devEnv.API_ROOT + "/process/getAll?factoryId=" + params).then(res => res.data) };
// 查询列表
export const processGetList = (params) => { return req("post", devEnv.API_ROOT + "/process/getList", params) };
// 创建和编辑
export const processSave = (params) => { return req("post", devEnv.API_ROOT + "/process/save", params) };


//---工艺路线
// 批量删除
export const technologyBatchDelete = (params) => { return req("post", devEnv.API_ROOT + "/technology/batchDelete", params) };
// 删除
export const technologyDelete = (params) => { return axios.get(devEnv.API_ROOT + "/technology/delete?_id=" + params).then(res => res.data) };
// 查询所有列表
export const technologyGetAll = (params) => { return axios.get(devEnv.API_ROOT + "/technology/getAll?factoryId=" + params).then(res => res.data) };
// 查询列表
export const technologyGetList = (params) => { return req("post", devEnv.API_ROOT + "/technology/getList", params) };
// 创建和编辑
export const technologySave = (params) => { return req("post", devEnv.API_ROOT + "/technology/save", params) };
//根据工艺路线查询所有工序
export const technologyGetAllProcess = (technologyCode, factoryId) => { return axios.get(devEnv.API_ROOT + "/technology/getAllProcess?technologyCode=" + technologyCode + "&factoryId=" + factoryId).then(res => res.data) };


//---物料清单
// 批量删除
export const materialBatchDelete = (params) => { return req("post", devEnv.API_ROOT + "/material/batchDelete", params) };
// 删除
export const materialDelete = (params) => { return axios.get(devEnv.API_ROOT + "/material/delete?_id=" + params).then(res => res.data) };
// 查询所有列表
export const materialGetAll = (params) => { return axios.get(devEnv.API_ROOT + "/material/getAll?factoryId=" + params).then(res => res.data) };
// 查询列表
export const materialGetList = (params) => { return req("post", devEnv.API_ROOT + "/material/getList", params) };
// 创建和编辑
export const materialSave = (params) => { return req("post", devEnv.API_ROOT + "/material/save", params) };

//---绩效工资配置
// 批量删除
export const salarySetBatchDelete = (params) => { return req("post", devEnv.API_ROOT + "/salarySet/batchDelete", params) };
// 删除
export const salarySetDelete = (params) => { return axios.get(devEnv.API_ROOT + "/salarySet/delete?_id=" + params).then(res => res.data) };
// 查询所有列表
export const salarySetGetAll = (params) => { return axios.get(devEnv.API_ROOT + "/salarySet/getAll?factoryId=" + params).then(res => res.data) };
// 查询列表
export const salarySetGetList = (params) => { return req("post", devEnv.API_ROOT + "/salarySet/getList", params) };
// 创建和编辑
export const salarySetSave = (params) => { return req("post", devEnv.API_ROOT + "/salarySet/save", params) };


/**
 * 库存管理
 */
//---入库单
// 批量删除
export const instockBatchDelete = (params) => { return req("post", devEnv.API_ROOT + "/instock/batchDelete", params) };
// 删除
// export const instockDelete = (params) => { return axios.get(devEnv.API_ROOT + "/instock/delete?_id=" + params).then(res => res.data) };
export const instockDelete = (params) => {  return req("post", devEnv.API_ROOT + "/instock/delete", params) };
// 查询列表
export const instockGetList = (params) => { return req("post", devEnv.API_ROOT + "/instock/getList", params) };
// 创建和编辑
export const instockSave = (params) => { return req("post", devEnv.API_ROOT + "/instock/save", params) };

//---出库单
// 批量删除
export const outstockBatchDelete = (params) => { return req("post", devEnv.API_ROOT + "/outstock/batchDelete", params) };
// 删除
// export const outstockDelete = (params) => { return axios.post(devEnv.API_ROOT + "/outstock/delete?_id=" + params).then(res => res.data) };
export const outstockDelete = (params) => { return req("post", devEnv.API_ROOT + "/outstock/delete", params) };
// 查询列表
export const outstockGetList = (params) => { return req("post", devEnv.API_ROOT + "/outstock/getList", params) };
// 创建和编辑
export const outstockSave = (params) => { return req("post", devEnv.API_ROOT + "/outstock/save", params) };

//---库存收发明细
export const outinstockGetList = (params) => { return req("post", devEnv.API_ROOT + "/outInStock/getList", params) };

/**
 * 库存管理
 */
//---任务
// 批量删除
export const taskBatchDelete = (params) => { return req("post", devEnv.API_ROOT + "/task/batchDelete", params) };
// 删除
export const taskDelete = (params) => { return axios.get(devEnv.API_ROOT + "/task/delete?_id=" + params).then(res => res.data) };
// 查询列表
export const taskGetList = (params) => { return req("post", devEnv.API_ROOT + "/task/getList", params) };
// 创建和编辑
export const taskSave = (params) => { return req("post", devEnv.API_ROOT + "/task/save", params) };


//---工单
// 批量删除
export const orderBatchDelete = (params) => { return req("post", devEnv.API_ROOT + "/order/batchDelete", params) };
// 删除
export const orderDelete = (params, factoryId, orderCode) => { return axios.get(devEnv.API_ROOT + "/order/delete?_id=" + params + '&factoryId=' + factoryId + '&orderCode=' + orderCode).then(res => res.data) };
// 查询所有列表
export const orderGetAll = (params) => { return axios.get(devEnv.API_ROOT + "/order/getAll?factoryId=" + params).then(res => res.data) };
// 查询列表
export const orderGetList = (params) => { return req("post", devEnv.API_ROOT + "/order/getList", params) };
// 创建和编辑
export const orderSave = (params) => { return req("post", devEnv.API_ROOT + "/order/save", params) };
//更新工单状态,用于工单的开始，结束，撤回，取消操作
export const orderUpdateStatus = (orderCode, operation, status) => { return axios.get(devEnv.API_ROOT + "/order/updateStatus?orderCode=" + orderCode + '&operation=' + operation + '&orderStatus=' + status).then(res => res.data) };
// 查询所有工单下所有工序（任务）
export const getAllTask = (params, orderCode) => { return axios.get(devEnv.API_ROOT + "/order/getAllTask?factoryId=" + params + '&orderCode=' + orderCode).then(res => res.data) };

// 查询所有工单列表
export const getAllOrder = (params) => { return req("post", devEnv.API_ROOT + "/order/getAll", params) };


//---报工
// 批量删除
export const enterBatchDelete = (params) => { return req("post", devEnv.API_ROOT + "/enter/batchDelete", params) };
// 删除
export const enterDelete = (params) => { return req("post", devEnv.API_ROOT + "/enter/delete", params) };
// 查询列表
export const enterGetList = (params) => { return req("post", devEnv.API_ROOT + "/enter/getList", params) };
// 创建和编辑
export const enterSave = (params) => { return req("post", devEnv.API_ROOT + "/enter/save", params) };


// 查询所有自定义配置列表（产品）
export const customSetGetAll = (params, collection) => { return axios.get(devEnv.API_ROOT + "/customSet/getAll?" + 'collection=' + collection + "&factoryId=" + params).then(res => res.data) };



// 大屏 - 工单产出分析
export const orderAnalysis = (params) => { return req("post", devEnv.API_ROOT + "/screen/orderAnalysis?factoryId=" + params.factoryId, params) };
// 不良品项分布
export const nongoodAnalysis = (params) => { return req("post", devEnv.API_ROOT + "/screen/nongoodAnalysis?factoryId=" + params.factoryId, params) };
// 上面中间区域数据
export const getOrderInfo = (params) => { return axios.get(devEnv.API_ROOT + "/screen/getOrderInfo?" + 'factoryId=' + params.factoryId).then(res => res.data) };



// WEBPACK FOOTER //
// ./src/api/basicData.js